import React from 'react';
import Header from './Header';

import { Outlet } from 'react-router-dom';
import GlobalLoader from './GlobalLoader';
import { LoaderProvider } from './LoaderContext';
import PayrollUploadLoader from './loader/PayrollUploadLoader';
import { PayloadUploadLoaderProvider } from './loader/PayrollUploadLoaderContext';
import { SnackbarProvider } from './SnackbarContext';
import LastLoginNotice from './LastLoginNotice';

const Layout = () => {
  const [loading, setLoading] = React.useState(true);
  return (
    <>
    <LoaderProvider>
      <PayloadUploadLoaderProvider>
        
      <Header />
      <main>
        <PayrollUploadLoader />
        <GlobalLoader />
        <SnackbarProvider>
        <LastLoginNotice />
        <Outlet /> {/* Renders the matched child route */}
        </SnackbarProvider>
      </main>
      
      </PayloadUploadLoaderProvider>
      </LoaderProvider>
    </>
  );
};

export default Layout;